import {cloudinaryApiKey} from '../config'

export const CLOUDINARY_UPLOAD_PRESET = 'obaxyyex'
export const CLOUDINARY_API_KEY = cloudinaryApiKey
export const CLOUDINARY_UPLOAD_URL =
  ' https://api.cloudinary.com/v1_1/ahmedeldessouki/image/upload'
